import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { StyledMakeDropdown } from 'site-modules/shared/components/vehicle-dropdowns/make-dropdown';
import { StyledZipInput } from 'site-modules/shared/components/styled-zip-input/styled-zip-input';
import { PUB_STATES } from 'client/constants/pub-states';

import './make-zip-selection.scss';

export class MakeZipSelection extends Component {
  static propTypes = {
    selectedMake: PropTypes.string,
    onSelectedMakeChange: PropTypes.func.isRequired,
    onGoBtnClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedMake: null,
  };

  state = {
    isZipChangeInProgress: false,
  };

  setZipChangeProgress = ({ isZipChangeInProgress }) => this.setState({ isZipChangeInProgress });

  render() {
    const { selectedMake, onSelectedMakeChange, onGoBtnClick } = this.props;
    const { isZipChangeInProgress } = this.state;

    return (
      <div className="make-zip-selection rounded-16 bg-white p-1_5" data-tracking-parent="edm-entry-dealer-search">
        <div className="text-cool-gray-10 size-20 fw-bold mb-1">Search dealership by make</div>
        <div className="d-flex flex-column flex-md-row">
          <StyledMakeDropdown
            value={selectedMake}
            onChange={onSelectedMakeChange}
            pubStates={[PUB_STATES.NEW, PUB_STATES.NEW_USED, PUB_STATES.USED]}
            size="lg"
            includeAllMakes
            className="rounded-8 text-cool-gray-40"
            wrapperClassName="col me-md-1 mb-1 mb-md-0"
          />
          <StyledZipInput
            onZipChangeInProgress={this.setZipChangeProgress}
            inputClasses="size-16 text-cool-gray-40 rounded-8"
            size="lg"
            isLabelHidden
          />
          <Button
            onClick={onGoBtnClick}
            disabled={!selectedMake || isZipChangeInProgress}
            color="blue-50"
            className="go-btn text-capitalize size-16 ms-md-1 mt-1 mt-md-0 rounded-8"
            data-tracking-id="click_search_dealer_btn"
            data-test="make-zip-selection-go-btn"
          >
            Go
          </Button>
        </div>
      </div>
    );
  }
}
